module.exports = __webpack_public_path__ + "c18dd861147b55633691229e595d3b7f.png";